import { Component, ElementRef, OnInit } from '@angular/core';
import { AuthService } from '@app/services/auth.service';
import { BadgeType } from '@humi-design-library/components/Badge/types';
import { BankAccount } from '@models/employee/bank-account.model';
import { Employee } from '@models/employee/employee.model';

@Component({
    templateUrl: './missing-data.view.html',
    styleUrls: ['./missing-data.style.scss'],
})
export class MissingDataReportView implements OnInit {
    isLoading = true;

    includeTerminated = false;

    reportableFields: any[] = [
        {
            label: 'reporting.reports.reportableFields.employmentType',
            key: 'employmentType',
        },
        {
            label: 'reporting.reports.reportableFields.paymentMethod',
            key: 'paymentMethod',
        },
        {
            label: 'reporting.reports.reportableFields.emergencyPrimaryContact',
            key: 'ecPrimaryName',
        },
        {
            label: 'reporting.reports.reportableFields.emergencyPrimaryRelation',
            key: 'ecPrimaryRelation',
        },
        {
            label: 'reporting.reports.reportableFields.emergencyPrimaryPhone',
            key: 'ecPrimaryPhone',
        },
    ];

    constructor(
        private element: ElementRef,
        private auth: AuthService
    ) {}

    ngOnInit(): void {
        this.getEmployees();
        this.renderCheckbox();
    }

    getCompletionPercentage(field: any): number {
        if (field.goodCount > 0 && field.totalCount > 0) {
            return Math.floor((field.goodCount / field.totalCount) * 100);
        }

        return 0;
    }

    openEmployee(employee: Employee): void {
        window.open('/employees/directory/' + employee.id);
    }

    toggleDetails(index: number): void {
        const row = $(this.element.nativeElement).find('tr[index="' + index + '"]');
        const details = $(this.element.nativeElement).find('tr[index="' + index + '"] .inner-details');
        if (row.css('display') !== 'none') {
            details.slideUp(() => {
                row.toggle();
            });
        } else {
            row.toggle();
            details.slideDown();
        }
    }

    getBadgeType(field: any): BadgeType {
        const percentage = this.getCompletionPercentage(field);

        if (percentage === 100) {
            return 'success';
        }
        if (percentage <= 50) {
            return 'danger';
        }

        return 'warning';
    }

    private getEmployees(): void {
        this.isLoading = true;
        Employee.param('company', this.auth.company.id)
            .when(!this.includeTerminated, (query) => {
                return query.whereIn('status', ['active', 'onboarding']);
            })
            .with('bankAccounts')
            .limit(0)
            .all()
            .then(([employees]) => {
                for (const reportableField of this.reportableFields) {
                    reportableField.goodCount = 0;
                    reportableField.employees = [];
                    for (const employee of employees) {
                        if (this.notEmptyOrNull(employee[reportableField.key])) {
                            reportableField.goodCount++;
                        } else {
                            reportableField.employees.push(employee);
                        }
                    }
                    reportableField.badCount = employees.length - reportableField.goodCount;
                    reportableField.totalCount = employees.length;
                }

                this.isLoading = false;
            });
    }

    private notEmptyOrNull(val: any): boolean {
        // handle bank accounts
        if (val instanceof BankAccount) {
            return Boolean(val['accountNumber']);
        }

        return val !== undefined && val !== null && val !== '';
    }

    private renderCheckbox(): void {
        $(this.element.nativeElement)
            .find('.ui.checkbox')
            .checkbox({
                onChecked: () => {
                    this.includeTerminated = true;
                    this.getEmployees();
                },
                onUnchecked: () => {
                    this.includeTerminated = false;
                    this.getEmployees();
                },
            });
    }
}
